import React, { Fragment, Component } from 'react';
import { Link } from 'react-router-dom';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import ToggleButton from 'react-bootstrap/ToggleButton';
import authService from '../../services/AuthService';

import './TopMenu.css';

export class TopMenu extends Component {

    render() {
        let extraValue = {};
        if (this.props.resetToMe) {
            extraValue['value'] = "ExtraME";
        }

        let partnerRole = authService.partnerRole;
        let isPartnerProvider = authService.isPartnerProvider;
        let isClearClinician = authService.isClearClinician;
        let isRaterOrCaregiver = authService.isRaterOrCaregiver;
        let displayExtraBtns = (this.props.cadeMode == "Analyze" || this.props.cadeMode == "Monitor" || this.props.cadeMode == "Report");
        let displayReportBtn = ((isPartnerProvider && partnerRole != 2) || isClearClinician) && authService.authenticatedUserRestrictedDomains == null;

        const topMenu = (
            <ButtonToolbar>
                <ToggleButtonGroup className={this.props.tourId} type="radio" name="options" defaultValue={this.props.cadeMode} justified="true">
                    <ToggleButton bsPrefix="btn btnWithExtras tour_input" value={'Input'} onClick={this.props.selectionHandler.bind(this, 'Input', authService.userType)}>Input</ToggleButton>

                    {((isPartnerProvider && partnerRole != 2) || isClearClinician) &&
                        <ToggleButton bsPrefix="btn btnWithExtras tour_analyze" value={'Analyze'} onClick={this.props.selectionHandler.bind(this, 'Analyze', authService.userType)}>Analyze</ToggleButton>
                    }

                    {((isPartnerProvider && partnerRole != 2) || isClearClinician) &&
                        <ToggleButton bsPrefix="btn btnWithExtras tour_monitor" value={'Monitor'} onClick={this.props.selectionHandler.bind(this, 'Monitor', authService.userType)}>Monitor</ToggleButton>
                    }

                    {displayReportBtn &&
                        <ToggleButton bsPrefix="btn tour_report" value={'Report'} onClick={this.props.selectionHandler.bind(this, 'Report', authService.userType)}>Report</ToggleButton>
                    }
                </ToggleButtonGroup>
                    
                {displayExtraBtns &&
                    <Fragment>
                    <ToggleButtonGroup className="topMenu_altAnalysis tour_inputSelectors" type="radio" name="altOptions" justified="true" {...extraValue} defaultValue="ExtraME">
                        {((isPartnerProvider && partnerRole != 2) || isClearClinician) &&
                        <ToggleButton value={'ExtraME'} onClick={this.props.selectionHandler.bind(this, this.props.cadeMode, 0)}>Your Input</ToggleButton>
                        }

                        {(isPartnerProvider && partnerRole != 2) && false &&
                            <ToggleButton value={'ExtraPP'} onClick={this.props.selectionHandler.bind(this, this.props.cadeMode, 1)}>Clinician</ToggleButton>
                        }

                        {isClearClinician &&
                            <ToggleButton value={'ExtraPP'} onClick={this.props.selectionHandler.bind(this, this.props.cadeMode, 2)}>CADE User</ToggleButton>
                        }

                        {((isPartnerProvider && partnerRole != 2) || isClearClinician) &&
                            <ToggleButton  value={'ExtraR1'} onClick={this.props.selectionHandler.bind(this, this.props.cadeMode, 4)}>Rater1</ToggleButton>
                        }

                        {((isPartnerProvider && partnerRole != 2) || isClearClinician) &&
                            <ToggleButton  value={'ExtraR2'} onClick={this.props.selectionHandler.bind(this, this.props.cadeMode, 5)}>Rater2</ToggleButton>
                        }

                        {((isPartnerProvider && partnerRole != 2) || isClearClinician) &&
                            <ToggleButton  value={'ExtraCG'} onClick={this.props.selectionHandler.bind(this, this.props.cadeMode, 3)}>Rater3</ToggleButton>
                        }

                    </ToggleButtonGroup>
                        
                    </Fragment>
                }
                <ButtonGroup className="topMenu_specialLogout">
                    {isRaterOrCaregiver &&
                        <Fragment>
                            <DropdownButton id="profileDropdown" title="Guest" variant="info" alignRight>
                                <Link to={{
                                    pathname: '/'
                                }}>
                                    <Dropdown.Item as="button">Logout</Dropdown.Item>
                                </Link>
                            </DropdownButton>
                            <span className="topMenu_clearLink">For more information about Clear Child for parents and clinicians, please click <a href="https://clearchildpsychology.com" target="_blank">here</a></span>
                        </Fragment>
                    }
                </ButtonGroup>
            </ButtonToolbar>
        );

        return topMenu;
    }
}

export default TopMenu;



// WEBPACK FOOTER //
// ./src/components/TopMenu/TopMenu.js